import { render } from "./SearchPage.vue?vue&type=template&id=2e6710f8&scoped=true&ts=true"
import script from "./SearchPage.vue?vue&type=script&lang=ts"
export * from "./SearchPage.vue?vue&type=script&lang=ts"

import "./SearchPage.vue?vue&type=style&index=0&id=2e6710f8&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6710f8"]])

export default __exports__